firebird.directive('amPopover', [
    '$parse',
    '$window',
    '$compile',
    function ($parse, $window, $compile) {
        return {
            restrict: 'E',
            link: function (scope, element, attrs) {
                element.hide();

                var mapToSelector = $parse(attrs.mapTo)(scope);
                var popoverClassName = $parse(attrs.className)(scope);
                var popover = null;
                var container = null;
                var shouldBeVisible = false;

                scope.amPopoverCloseClick = function () {
                    scope.$eval(attrs.onClose);
                    if (container) {
                        hidePopover();
                    }
                };

                scope.$watch(attrs.show, function (newValue, oldValue) {
                    if (newValue && !oldValue) {
                        if (!popover) {
                            initPopover();
                        }

                        showPopover();
                    } else if (!newValue && oldValue) {
                        hidePopover();
                    }
                });

                function initPopover() {
                    container = $window.$(mapToSelector);
                    popover = container.popover({
                        container: 'body',
                        html: true,
                        trigger: 'manual',
                        content: createPopoverTemplate()
                    });
                    popover.data('bs.popover').tip().addClass(popoverClassName).addClass('am-popover');

                    // there could be a case when we call $window.$('.popover').popover('hide') somewhere in code
                    // but we still need to display this popover
                    popover.on('hidden.bs.popover', function () {
                        if (shouldBeVisible) {
                            showPopover();
                        }
                    });
                }

                function showPopover() {
                    shouldBeVisible = true;
                    container.popover('show');
                }

                function hidePopover() {
                    shouldBeVisible = false;
                    container.popover('hide');
                }

                function createPopoverTemplate() {
                    element.append(
                        '<span class="am-popover-close-btn" ng-click="amPopoverCloseClick()"><i class="zmdi zmdi-close"></i></span>'
                    );
                    return $compile(element.html())(scope);
                }
            }
        };
    }
]);
